export default class LoginInfo { 
    constructor(){
        // this.firstname
        // this.lastname
        // this.personname
        // this.contact
        // this.personemail
        // this.token
        // this.unqkey
        // this.uid
        // this?.subdomainname
        // this.userroles
        // this.branches
        // this.userroleid
        // this.branchid
        // this.companyid
        // this.profilepic
    }

    setFirstname(firstname){
        this.firstname = firstname
    }
    setLastname(lastname){
        this.lastname = lastname
    }
    setPersonname(personname){
        this.personname = personname
    }
    setContact(contact){
        this.contact = contact
    }
    setPersonemail(personemail){
        this.personemail = personemail
    }
    setWorkemail(workemail){
        this.workemail = workemail
    }
    setToken(token){
        this.token = token
    }
    setUnqkey(unqkey){
        this.unqkey = unqkey
    }
    setUid(uid){
        this.uid = uid
    }
    setSubdomainName(subdomainname){
        this.subdomainname = subdomainname
    }
    setUserroles(userroles){
        this.userroles = userroles
    }
    setBranches(branches){
        this.branches = branches
    }
    setUserroleID(userroleid){
        this.userroleid = userroleid
    }
    setBranchID(branchid){
        this.branchid = branchid
    }
    setCompanyID(companyid){
        this.companyid = companyid
    }

    setCompanyCountryID(companycountryid){
        this.companycountryid = companycountryid
    }

    setCompanyStateId(companystateid){
        this.companystateid = companystateid
    }

    setCompanyCityId(companycityid){
        this.companycityid = companycityid
    }

    setCompanyName(companyname) {
        this.companyname = companyname
    }
    setProfilePic(profilepic) {
        this.profilepic = profilepic
    }
    setStatus(status) {
        this.status = status
    }
    setIsActive(isactive){
        this.isactive = isactive
    }
    setTheme(theme) {
        this.theme = theme
    }
    setDateFormate(dateformat){
        this.dateformat = dateformat
    }
    setTimeFormate(timeformat){
        this.timeformat = timeformat
    }
    setBirthDate(birthdate){
        this.birthdate = birthdate
    }

    setIsBirthdate(status){
        this.isbirthdate = status
    }
    setBirthDayMessage(birthdaymsg){
        this.birthdaymsg = birthdaymsg
    }
    setAnniversaryMessage(anniversarymsg){
        this.anniversarymsg = anniversarymsg
    }
    setIsAnnivarsary(anniversary){
        this.isAnnivarsary=anniversary
    }
    setIsCustomer(customer){
        this.iscustomer=customer
    }
    setOrgconfiguration(orgconfiguration){
        this.orgconfiguration=orgconfiguration           
    }
    
    getFirstname(){
        return this.firstname 
    }
    getLastname(){
        return this.lastname 
    }
    getPersonname(){
        return this.personname
    }
    getContact(){
        return this.contact
    }
    getPersonemail(){
        return this.personemail
    }
    getWorkemail(){
        return this.workemail
    }
    getToken(){
        return this.token
    }
    getUnqkey(){
        return this.unqkey
    }
    getUid(){
        return this.uid
    }
    getSubdomainName(){
        return this.subdomainname
    }
    getUserroles(){
        return this.userroles
    }
    getBranches(){
        return this.branches
    }
    getUserroleID(){
        return this.userroleid
    }
    getBranchID(){
        return this.branchid
    }
    getCompanyID(){
        return this.companyid
    }
    getCompanyName() {
        return this.companyname
    }
    getProfilePic() {
        return this.profilepic 
    }
    getStatus() {
        return this.status 
    }
    getIsActive(){
        return this.isactive 
    }
    getTheme() {
        return this.theme
    }
    getDateFormate(dateformat){
        return this.dateformat
    }
    getTimeFormate(timeformat){
        return this.timeformat 
    }
    getBirthDate(timeformat){
        return this.birthdate 
    }
    getOrgconfiguration(){
        return this.orgconfiguration 
    }
    getBirthDayMessage(){
        return this.birthdaymsg
    }
    getAnniversaryMessage(){
        return this.anniversarymsg
    }

}